module.exports = __webpack_public_path__ + "img/calendar.7d3ab2d0.svg";